import "./styles.css";
import { useState, useEffect } from "react";
import { Button, Input, TextField } from "@material-ui/core";
import Backdrop from "@material-ui/core/Backdrop";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import { red } from "@material-ui/core/colors";
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: theme.spacing(2),

    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "300px"
    },
    "& .MuiFormLabel-root": {
      color: "#DAD7E9", // or black
      outline: "red",
      fontSize: "13px",
      input: {
        color: "white"
      }
    },
    "& .MuiButtonBase-root": {
      margin: theme.spacing(2)
    },
    "& .MuiInputBase-root": {
      color: "#f0eae4",
      fontStyle: "san-serif",
      fontSize: "14px"
    },
    input: {
      backgroundColor: "white",
      color: "white"
    },
    TextField: {
      color: "white"
    },
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: "#fff"
    }
  }
}));

export default function Progress() {
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [flag, setFlag] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [filteredResult, setFilteredResults] = useState([]);
  const fetchData = async () => {
    const res = await fetch("https://app.sheetlabs.com/KIN/Progress");
    const data = await res.json();
    setData(data);
    data ? setFlag(true) : setFlag(false);
  };
  useEffect(() => {
    fetchData();
  }, []);
  const styling = {
    floatingLabelFocusStyle: {
      textField: {
        color: "white"
      }
    }
  };
  const inputHandler = (event) => {
    setSearchInput(event.target.value);

    if (searchInput !== "") {
      const filteredData = data.filter((item) => {
        return Object.values(item)
          .join("")
          .toLowerCase()
          .includes(searchInput.toLowerCase());
      });
      setFilteredResults(filteredData);
    } else {
      setFilteredResults(data);
    }
  };

  const restricted = ["Total Problem", "126", null, "Name"];
  return (
    <div>
      {!flag ? (
        <div>
          <Backdrop className={classes.backdrop} open>
            {" "}
            <CircularProgress color="inherit" />{" "}
          </Backdrop>
        </div>
      ) : (
        ""
      )}
      <div style={{ paddingTop: 30, margin: 5, color: "white" }}>
        <h3>📊 Welcome A2SV community </h3>
        <form className={classes.root}>
          <TextField
            sx={{ input: { color: "white" } }}
            floatingLabelFocusStyle={styling.floatingLabelFocusStyle}
            label="Search for name"
            variant="outlined"
            required
            className={classes.textField}
            name="name"
            onChange={inputHandler}
            active
          />
        </form>
        {searchInput
          ? filteredResult.map((p) => {
              return (
                <div style={{ textAlign: "left" }}>
                  <p> 👤 NAME ➖ {p.column1}</p>
                  <pre
                    style={{
                      paddingLeft: 50,
                      marginBottom: 7.5,
                      color: "rgb(169, 185, 235)",
                      marginTop: 9
                    }}
                  >
                    ✅ RANK ➖ {p.column2}
                  </pre>
                  <pre
                    style={{
                      paddingLeft: 50,
                      marginBottom: 7.5,
                      color: "rgb(169, 185, 235)",
                      marginTop: 13
                    }}
                  >
                    ✅ SOLVED QUESTION ➖ {p.column3} out of 126 (
                    {126 - parseInt(p.column3)} left)
                  </pre>
                  <pre
                    style={{
                      paddingLeft: 50,
                      marginBottom: 11,
                      marginTop: 13,
                      color: "rgb(169, 185, 235)"
                    }}
                  >
                    ✅ TOTAL SUBMISSION ➖ {p.column4}
                  </pre>
                </div>
              );
            })
          : data.map((p) => {
              return (
                <div style={{ textAlign: "left" }}>
                  {restricted.includes(p.column1) || p.column1 === " " ? (
                    ""
                  ) : (
                    <>
                      {" "}
                      <p> 👤 NAME ➖ {p.column1}</p>
                      <pre
                        style={{
                          paddingLeft: 50,
                          marginBottom: 7.5,
                          color: "rgb(169, 185, 235)",
                          marginTop: 9
                        }}
                      >
                        ✅ RANK ➖ {p.column2}
                      </pre>
                      <pre
                        style={{
                          paddingLeft: 50,
                          marginBottom: 7.5,
                          color: "rgb(169, 185, 235)",
                          marginTop: 13
                        }}
                      >
                        ✅ SOLVED QUESTION ➖ {p.column3} out of 126 (
                        {126 - parseInt(p.column3)} left)
                      </pre>
                      <pre
                        style={{
                          paddingLeft: 50,
                          marginBottom: 11,
                          marginTop: 13,
                          color: "rgb(169, 185, 235)"
                        }}
                      >
                        ✅ TOTAL SUBMISSION ➖ {p.column4}
                      </pre>
                    </>
                  )}
                </div>
              );
            })}
      </div>
    </div>
  );
}
